import Seo from '../components/Seo'

/**
 * Catch-all 404 page. Marked noindex so Google does not index SPA-fallback
 * soft-404s (unknown paths still return 200 for client-side routing of dynamic
 * routes, but should not be indexed).
 */
export default function NotFoundPage() {
  return (
    <main className="pt-24 max-w-3xl mx-auto px-6">
      <Seo title="Page not found" path="/404" noindex />
      <h1 className="font-heading text-3xl text-ink">Page not found</h1>
      <p className="text-gs-text-soft mt-2">The page you were looking for isn&apos;t here.</p>
      <a href="/" className="mt-4 inline-block text-sm underline">Go home</a>
    </main>
  )
}
